define([
    "./monitorableModule",
    "lodash",
], function (monitorableModule, _) {
    "use strict";

    return monitorableModule.controller("MonitorableEditionController", [
        "$scope",
        "$q",
        "$state",
        "$stateParams",
        "loadingService",
        "remoteExceptionHandler",
        "monitoringBasketService",
        "monitorable",
        "monitoringService",
        "monitorableService",
        "completionService",
        "CompletionStatus",
        "alterDriverModal",
        "monitoringVelocityConfigurationModal",
        "monitorableItemExtensionDialog",
        "tpfModal",
        function ($scope,
                  $q,
                  $state,
                  $stateParams,
                  loadingService,
                  remoteExceptionHandler,
                  monitoringBasketService,
                  monitorable,
                  monitoringService,
                  monitorableService,
                  completionService,
                  CompletionStatus,
                  alterDriverModal,
                  monitoringVelocityConfigurationModal,
                  monitorableItemExtensionDialog,
                  tpfModal) {

            $scope.entity = prepareData(monitorable);
            $scope.transitions = extractTransitions($scope.entity);
            $scope.isRoot = monitorable.root;
            $scope.monitorableStatus = {};
            $scope.occurrencesDetails = {};
            $scope.rootMonitorablePresentationTreeNode = {};
            $scope.refresh = reloadEntityWithLoadingService;
            $scope.monitoringBasketService = monitoringBasketService;
            $scope.monitorable = monitorable;
            $scope.tracking = {
                truckDevice: {},
                lastSignal: null,
                shouldDisplayRealizedPath: true,
                trackingMonitorablesByClassification: {
                    primary: {
                        trackingMonitorables: [],
                        isAllSelected: false,
                    },
                    secondary: {
                        trackingMonitorables: [],
                    },
                    isPrimaryView: true,
                }
            };

            $scope.monitorableTemperatureTrackingDetails = [];

            $scope.collapseMonitorableEdition = {
                active: true,
                panelMonitorable: false,
                panelOccurrences: false,
                panelTracking: false,
                panelExtensions: false,
                panelItems: false,
            }

            let hereMapApi = null
            $scope.onRegisterHereApi = (api) => {
                hereMapApi = api
            }


            $scope.serviceClick = function (service) {
                if (!service.locality) {
                    return;
                }
                if (hereMapApi) {
                    hereMapApi.focusOnStop(service.locality);
                }
            };

            function TemperatureTrackingDetails(providerId, sensorIdentifier) {
                this.providerId = providerId;
                this.sensorIdentifier = sensorIdentifier;
                this.temperature = "N/A";
            }

            TemperatureTrackingDetails.prototype = {
                setTemperature(temperature) {
                    this.temperature = temperature;
                }
            };

            var tabParam = $stateParams.tab || "general";
            $scope.tabs = {
                "general": tabParam === "general",
                "details": tabParam === "details",
                "hierarchy": tabParam === "hierarchy",
                "transitions": tabParam === "transitions",
                "occurrences": tabParam === "occurrences"
            };

            init();

            $scope.back = function () {
                return $state.go("monitoring.monitoringMonitorableSearch");
            };

            $scope.isEnabled = function () {
                return completionService.isActive($scope.entity.completion.status);
            };

            $scope.isInExecution = function () {
                if ($scope.isRoot) {
                    return CompletionStatus.IN_EXECUTION === $scope.entity.completion.status;
                }
                return !$scope.isRoot;
            };

            $scope.hasPermission = function () {
                return !$scope.isRoot
            };

            $scope.startMonitorable = function () {
                return monitorableService.startMonitorables([$scope.entity.id])
                    .then(reloadEntityWithLoadingService);
            };

            $scope.updateDriver = function () {
                return alterDriverModal($scope.entity)
                    .then(reloadEntityWithLoadingService);
            };

            $scope.editTripConfiguration = function () {
                return monitoringVelocityConfigurationModal($scope.entity)
                    .then(reloadEntityWithLoadingService);
            };

            $scope.finishMonitorable = function () {
                return monitorableService.finishMonitorables([$scope.entity.id])
                    .then(reloadEntityWithLoadingService);
            };

            $scope.cancelMonitorable = function () {
                return monitorableService.cancelMonitorables([$scope.entity.id])
                    .then(reloadEntityWithLoadingService);
            };

            $scope.hasCurrentTransitionExecuted = function (monitorableStatus) {
                if (monitorableStatus.currentTransition !== undefined && monitorableStatus.lastTransitionExecuted) {
                    return monitorableStatus.currentTransition.name === monitorableStatus.lastTransitionExecuted.name
                        || monitorableStatus.currentTransition.status === "br.com.neolog.monitoring.monitorable.model.api.transition.TransitionStatus.FINALIZED";
                }
            };

            $scope.inspectExtension = function (item) {
                monitorableItemExtensionDialog(item);
            };


            function init() {
                return $q.all([
                    loadEntityStatus(),
                    loadConfiguration()
                ]);
            }

            function loadEntityStatus() {
                return $q.all([
                    loadMonitorableStatus(),
                    loadOccurrencesDetails(),
                    loadRootPresentationTreeNode(),
                ]);
            }

            function reloadEntityWithLoadingService() {
                return loadingService(reloadEntity());
            }

            function reloadEntity() {
                return monitoringService.findMonitorableAssociatedTransitionGroupWithSameLocality($scope.entity.id)
                    .catch(remoteExceptionHandler())
                    .then(function (monitorable) {
                        $scope.entity = monitorable;
                    })
                    .then(loadEntityStatus)
            }

            function loadMonitorableStatus() {
                return monitorableService.findMonitorableStatus($scope.entity.id)
                    .then(function (monitorableStatus) {
                        $scope.monitorableStatus = monitorableStatus;
                    });
            }

            function loadOccurrencesDetails() {
                return monitoringService.findOccurrencesDetails($scope.entity.id)
                    .then(function (occurrencesDetails) {
                        $scope.occurrencesDetails = occurrencesDetails;
                    });
            }

            function loadRootPresentationTreeNode() {
                return monitorableService.findRootMonitorablePresentationTreeById($scope.entity.id)
                    .then(function (presentationNode) {
                        // remove o commands da tela Monitoráveis -> Detahes -> Hierarquia
                        presentationNode.commands = []
                        $scope.rootMonitorablePresentationTreeNode = presentationNode;
                    });
            }

            $scope.getFinishedTruckDeviceTooltip = function (status) {
                if (isFinishedTrackingMonitorable(status)) {
                    return "tracking.truckDevice.finished.truckDevice.tooltip";
                }
                return "";
            };

            function isFinishedTrackingMonitorable(status) {
                return status === CompletionStatus.FINISHED;
            }

            function loadConfiguration() {
                return $q.all([
                    loadMonitorableVelocities(),
                    loadSensorsConfiguration()
                ]);
            }

            $scope.sensorsConfiguration = [];

            function loadSensorsConfiguration() {
                return monitoringService.getTemperatureSensorConfigurations($scope.entity.id)
                    .then(function (providerSensorConfigurationMap) {
                        let providers = Object.keys(providerSensorConfigurationMap);
                        for (let provider of providers) {
                            providerSensorConfigurationMap[provider].forEach(function (sensorConfiguration) {
                                $scope.sensorsConfiguration.push(sensorConfiguration);
                                $scope.monitorableTemperatureTrackingDetails.push(new TemperatureTrackingDetails(sensorConfiguration.providerId,
                                    sensorConfiguration.identifier));
                            })
                        }
                        sortTemperatureTrackingDetails($scope.monitorableTemperatureTrackingDetails);
                    });
            }

            function loadMonitorableVelocities() {
                return monitoringService.getTripConfiguration($scope.entity.id)
                    .then(function (configuration) {
                        $scope.monitorableConfiguration = {
                            maxVelocity: configuration.maxVelocity,
                            minVelocity: configuration.minVelocity,
                        }
                    });
            }

            $scope.getSensorsConfiguration = (providerId) => {
                return $scope.sensorsConfiguration.filter(s => s.providerId === providerId);
            };


            function prepareData(monitorable) {
                monitorable['lastOccurrence'] = getLastOccurrence(monitorable);
                monitorable['nextTransition'] = getNextTransition(monitorable);
                monitorable['lastExecutedTransition'] = getLastExecutedTransition(monitorable);
                return monitorable;
            }

            function getLastOccurrence(monitorable) {
                if (_.isEmpty(monitorable.occurrences)) {
                    return "";
                }
                var occurrence = monitorable.occurrences[monitorable.occurrences.length - 1];
                return occurrence.category.name + " - " + occurrence.cause.name;
            }

            function getNextTransition(monitorable) {
                var transitions = extractTransitions(monitorable);
                var reversed = transitions.slice().reverse();
                if (_.isEmpty(reversed)) {
                    return "";
                }
                if (reversed[0].finalizedTimestamp > 0) {
                    return "";
                }
                reversed.forEach(function (transition) {
                    if (transition.finalizedTimestamp > 0) {
                        return reversed[reversed.indexOf(transition) - 1].name;
                    }
                });
                return transitions[0].name;
            }

            function getLastExecutedTransition(monitorable) {
                var transitions = extractTransitions(monitorable);
                var finalizedTransitions = transitions.filter(function (transition) {
                    return transition.finalizedTimestamp > 0;
                });
                if (_.isEmpty(finalizedTransitions)) {
                    return "";
                }
                finalizedTransitions = _.sortBy(finalizedTransitions, 'finalizedTimestamp');
                return finalizedTransitions[finalizedTransitions.length - 1].name;
            }

            function extractTransitions(monitorable) {
                var transitions = [];
                monitorable.transitionGroups.forEach(function (transitionGroups) {
                    sortTransitions(transitionGroups.transitions).forEach(function (transition) {
                        transitions.push(transition);
                    })
                });
                return transitions;
            }

            function sortTransitions(transitions) {
                transitions.sort((t1, t2) => {
                    const dateCompare = new Date(t1.expectedTimestamp).getTime() - new Date(t2.expectedTimestamp).getTime();
                    if (dateCompare !== 0) {
                        return dateCompare;
                    }
                    return t1.id - t2.id;
                });
                return transitions;
            }

            $scope.getTravelledDistance = function (data) {
                if (!data) {
                    return "N/A";
                }
                if (!data.travelledDistance) {
                    return 0;
                }
                return data.travelledDistance;
            };

            $scope.getOrNA = function (data) {
                if (data === "" || data == null || data === 0 || data.length === 0) {
                    return "N/A";
                }
                return data;
            };

            $scope.formatTemperature = function (temperature) {
                if (temperature === "N/A") {
                    return temperature;
                }
                return temperature + "ºC";
            };

            $scope.getTemperatureDetails = function () {
                let temperaturesDetails = extractTemperatureDetails($scope.entity);
                associateTemperatureDetailsWithSensorConfiguration(temperaturesDetails);
                return $scope.monitorableTemperatureTrackingDetails;
            };

            function extractTemperatureDetails(entity) {
                if (!(entity.trackingDetails && entity.trackingDetails.temperatureDetails)) {
                    return [];
                }
                return entity.trackingDetails.temperatureDetails;
            }

            function associateTemperatureDetailsWithSensorConfiguration(temperaturesDetails) {
                for (let temperatureDetails of temperaturesDetails) {
                    let trackingDetails = $scope.monitorableTemperatureTrackingDetails
                        .find(ttd => ttd.providerId === temperatureDetails.providerId
                            && ttd.sensorIdentifier === temperatureDetails.sensorIdentifier);
                    if (trackingDetails) {
                        trackingDetails.setTemperature(temperatureDetails.temperature);
                    }
                }
            }

            function sortTemperatureTrackingDetails(temperatureTrackingDetails) {
                temperatureTrackingDetails.sort(function (s1, s2) {
                    return s1.sensorIdentifier - s2.sensorIdentifier;
                });
                return temperatureTrackingDetails.sort(sortByProvider);
            }

            function sortByProvider(sensorConfiguration1, sensorConfiguration2) {
                if (sensorConfiguration1.providerId > sensorConfiguration2.providerId) {
                    return 1;
                }
                if (sensorConfiguration1.providerId < sensorConfiguration2.providerId) {
                    return -1;
                }
                return 0;
            }

            $scope.openTPFModal = function (invoice) {
                if (invoice.typeName === "INVOICE") {
                    tpfModal(invoice);
                }
            }
        }
    ]);
});
